module.exports = __webpack_public_path__ + "static/media/location-fungus.ca9e9819.png";